import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Vue Router
import router from './router'

// Theme Configurations
import '../themeConfig.js'

// Vue Lodash
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

// number animation
import VueNumber from 'vue-number-animation'

Vue.use(VueNumber)

Vue.use(VueLodash, {lodash})

//youtube embeded
import Embed from "v-video-embed";

Vue.use(Embed);

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vuex Store
import store from './store/store'

// // vue carousel
import Carousel3d from 'vue-carousel-3d'

Vue.use(Carousel3d)


//vue youtube embeded
import VueYouTubeEmbed from 'vue-youtube-embed'

Vue.use(VueYouTubeEmbed, {global: true, componentId: 'youtube-media'})

// v-touch
import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})

// moment js
import vueMoment from 'vue-moment'

Vue.use(vueMoment)

// gsap
import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {MotionPathPlugin} from 'gsap/MotionPathPlugin'
// import CSSPlugin from 'gsap/dist/CSSPlugin'
// import ScrollToPlugin from 'gsap/ScrollToPlugin'
// gsap.registerPlugin(CSSPlugin)
// ScrollTrigger
// Vue.mixin({
//   created () {
//     this.$gsap = gsap
//     this.$scrollTrigger = ScrollTrigger
//   }
// })
Vue.prototype.$gsap = gsap
Vue.prototype.$scrollTrigger = ScrollTrigger
Vue.prototype.$motionPlugin = MotionPathPlugin

Vue.prototype.$scrollTrigger.config({
    // default is "resize,visibilitychange,DOMContentLoaded,load" so we can remove "resize" from the list:
    autoRefreshEvents: 'DOMContentLoaded,load',
    // autoRefreshEvents: 'resize,visibilitychange',
    ignoreMobileResize: true
})
// Vue.prototype.$scrollTrigger.addEventListener('scrollStart', (...a) => {
//   console.log(a)
// })
Vue.prototype.$gsap.registerPlugin(Vue.prototype.$scrollTrigger, Vue.prototype.$motionPlugin)
Vue.prototype.$gsap.core.globals('ScrollTrigger', Vue.prototype.$scrollTrigger)
Vue.prototype.$gsap.core.globals('MotionPathPlugin', Vue.prototype.$motionPlugin)

// Vue.prototype.$gsap = gsap
// Vue.prototype.$scrollTrigger = ScrollTrigger

// i18n
import i18n from './i18n/i18n'

// Vuexy Admin Filters
import './filters/filters'

// Vuejs - Vue wrapper for hammerjs
// import {VueHammer} from 'vue2-hammer'
//
// Vue.use(VueHammer)

// Vue.config.errorHandler = (err) => alert(err)
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// mdicon
import mdiVue from 'mdi-vue'
import * as mdijs from '@mdi/js'
import * as mdijsAdd from '@/plugins/mdi/additionalIcons'

Vue.use(mdiVue, {
    icons: Object.assign(Object.assign({}, mdijs), mdijsAdd)
})

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
import FloatingVue from 'floating-vue'

Vue.use(FloatingVue)
import 'floating-vue/dist/style.css'

Vue.config.productionTip = false
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
